import React,{Component} from 'react';
import { apisettigs } from '../../../src/settings.js';


class Cotacoes extends Component{
    constructor(props) {        
        super(props);

        this.state = {
            show: false,  
            rqid: null,
            quotations: [],
        };
    }

    showCotacoes = (reqid) => {
        this.setState({show: true});
        this.setState({rqid:reqid});

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId"), rid: reqid })
        };

        fetch(apisettigs.endpoints.listquotations, requestOptions).then(response => response.json())
        .then(data => {
            //console.log(data);
            this.setState({quotations: data});
        });
    }


    hideCotacoes = () => {
        this.setState({show: false});
        this.setState({rqid: null});
        this.setState({quotations:[]});
    }


    voltar = () => {
        this.hideCotacoes();
        this.props.showOrd();
    }

    quotSelected = (optsel) => {
        //console.log('iopt - ',optsel);
        if (optsel === 'X'){
            return(
                <i class="fas fa-check" style={{color:'#0025A8'}}></i> 
            )
        }
        else{
            return(
                ''
            )
        }
        
    }

    render(){

        if(this.state.show === true){
            return(
                <>
                    <div className='msgTopCont mb-3'>
                        Cotações
                    </div>

                    {this.state.quotations.map((quots) => {
                        return(
                            <div className='container'>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg ' style={{width:'5rem',}} >
                                        Fornecedor
                                    </div>
                                    <div className='col- align-self-center colTextItm ' style={{maxWidth:'70%',lineHeight:'.95rem'}} >
                                        {quots.supplier}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg ' style={{width:'5rem',}} >
                                        Qtd.Itens
                                    </div>
                                    <div className='col- align-self-center colTextItm '  style={{maxWidth:'70%',}}>
                                        {quots.quantity}
                                    </div>
                                   
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg ' style={{width:'5rem'}} >
                                        Total
                                    </div>
                                    <div className='col- align-self-center colTextItm ' style={{maxWidth:'64%',}}>
                                        {quots.totVal}
                                    </div>
                                    <div className='col- align-self-center colTextItm ' style={{width:'1rem',padding:'0'}}>
                                        {this.quotSelected(quots.selected)}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg ' style={{width:'5rem'}} >
                                        Dt.Receb.
                                    </div>
                                    <div className='col- align-self-center colTextItm  ' style={{maxWidth:'70%',}}>
                                        {quots.receiptDate}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg  ' style={{width:'5rem'}} >
                                        Obs.
                                    </div>
                                    <div className='col- align-self-center colTextItm ' style={{maxWidth:'70%',}} >
                                        {quots.remark}
                                    </div>                                    
                                </div>
                                <hr className='hLn2 mt-2'/>
                            </div>
                        )
                    })}

                    <div className='container mt-4 mb-4 text-center'>
                        <button type="button" className="btn btn-outline-primary msgBtn2" onClick={this.voltar}>Voltar</button>
                    </div>

                </>
            );
        }
        else{
            return null;
        }
    }





}

export default Cotacoes